<template lang="pug">
.header
  ManagementPage(:title="$t('settings_tab.integraions_tab.sharepoint.title')"
                :info="$t('settings_tab.integraions_tab.sharepoint.description')"
                :creatable="false"
                :searchable="false")

.form-container
    .sub-header--solid Enabled
      aiq-switch.margin-left-10(:model-value="config.enabled" @change="onEnabled"
                                style="--aiq-switch-on-color: #30C28B; --aiq-switch-off-color: #C0CCDA")
.shared-auth-config(v-if="config.enabled")
  .oauth-configuration
    .form-container
      .sub-header--solid {{ title }}
      .form__inner-content
        .form-field-container
          .form-field-label {{ $t('settings_tab.integraions_tab.sharepoint.client_id') }}
          aiq-input(v-model="config.configuration.client_id"
                    :placeholder="$t('settings_tab.integraions_tab.sharepoint.client_id')"
                    size="small"
                    @keydown.enter="saveCredentials()")
        .form-field-container
          .form-field-label {{ $t('settings_tab.integraions_tab.sharepoint.client_secret') }}
          aiq-input(v-model="config.configuration.client_secret"
                    :placeholder="$t('settings_tab.integraions_tab.sharepoint.client_secret')"
                    size="small"
                    type="password"
                    @keydown.enter="saveCredentials()")
        .form-field-container
          .form-field-label {{ $t('settings_tab.integraions_tab.sharepoint.tenant_id') }}
          aiq-input(v-model="config.configuration.tenant_id"
                    :placeholder="$t('settings_tab.integraions_tab.sharepoint.tenant_id')"
                    size="small"
                    @keydown.enter="saveCredentials()")
</template>

<script>
import ManagementPage from '@/components/ManagementPage/ManagementPage.vue';

export default {
  name: 'Sharepoint',
  components: {
    ManagementPage,
  },
  computed: {
    title() {
      return this.$t('settings_tab.integraions_tab.sharepoint.config');
    },
    name() {
      return this.$t('settings_tab.integraions_tab.sharepoint.name');
    },
  },
  async mounted() {
    if (!this.name) {
      throw new Error(`name attribute should be set to use this component but ${this.name}`);
    }

    this.config = await this.$store.dispatch('integrations/getIntegration', { name: this.name });
  },
  methods: {
    onEnabled(value) {
      this.config.enabled = value;
      this.saveCredentials();
    },
    async saveCredentials() {
      try {
        this.config = await this.$store.dispatch('integrations/updateIntegration', {
          name: this.name,
          payload: this.config,
        });
        this.$aiq.notify.success('Updated');
      } catch (err) {
        this.$aiq.notify.error(`Failed: ${err.message}`);
      }
    },
  },
  data() {
    return {
      config: null,
    };
  },
};
</script>

<style lang="scss" scoped>
.form__inner-content {
  background: #FFFFFF;
  border: 1px solid #E0E6ED;
  display: flex;
  flex-direction: column;
  padding: 18px;
}

.form-field-container {
  margin-bottom: 5px;
  margin-top: 5px;
  display: flex;
  justify-content: space-between;
  width: 350px;
}

.form-field-label {
  font-weight: 500;
}
</style>